const allProducts = [
  {
    id: 1,
    name: "RC850IMR",
    title: "Elegant Maggam Blouse",
    category: "maggam-work",
    price: 850,
    original: 1400,
    stockQty: 7,
    description: `
1 MTR COTTON SILK CLOTH  
MIRCHI RED COLOUR  
MAGGAM WORK BLOUSE  
NECK DEEP 10 TO 11 INCHES (APPROX)  
HAND LENGTH 10 INCHES (APPROX).  
    `,
    image: "/blouse.jpg",
  },
  {
    id: 2,
    name: "RC1400BR",
    title: "Bridal Heavy Work Blouse",
    category: "bridal",
    price: 1400,
    original: 2500,
    stockQty: 0,
    image: "/images/bridal1.jpg",
    description: "Premium bridal work blouse with heavy stone work.",
  },
  {
    id: 3,
    name: "RC650SIM",
    title: "Simple Blouse",
    category: "simple",
    price: 650,
    original: 900,
    stockQty: 5,
    image: "/images/simple1.jpg",
    description: "Classic plain simple blouse.",
  }
];

export default allProducts;
